import {useEffect, useState} from 'react'
import {getArchitecture, type Architecture} from '@github-ui/get-os'

export function useArchitecture(enabled = true): Architecture | undefined {
  const [architecture, setArchitecture] = useState<Architecture | undefined>(undefined)

  useEffect(() => {
    if (!enabled) return

    let cancelled = false
    void (async () => {
      const arch = await getArchitecture()
      if (!cancelled && arch) setArchitecture(arch)
    })()
    return () => {
      cancelled = true
    }
  }, [enabled])

  return enabled ? architecture : undefined
}
